import { connect } from 'react-redux';
import { useCallback, useState } from 'react';

import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { getKnmFormRef } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { Row } from '../../UIPackage/FormModule/components/Row';
import { FieldBlock } from '../../UIPackage/FormModule/components/FieldBlock';
import { CommonCatalogsNamesEnum } from '../../CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { SelectInputFieldAutoOptions } from '../../UIPackage/MainModule/components/SelectInputFieldAutoOptions';
import { TextInputField } from '../../UIPackage/MainModule/components/TextInputField';
import { IKnmErknmFormJudgmentAgainstInfo } from '../MainModule/interfaces/IKnmErknmFormJudgmentAgainstInfo';
import { IKnmErknmForm } from '../MainModule/interfaces/IKnmErknmForm';
import { IKnmJudgmentPunishmentIndexSelectOption } from '../../CorePackage/CatalogsModule/interfaces/IKnmJudgmentPunishmentIndexSelectOption';
import { getJudgmentPunishmentIndexSelectOptions } from '../../CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { SelectInputField } from '../../UIPackage/MainModule/components/SelectInputField';
import { IKnmJudgmentPunishmentTypeSelectOption } from '../../CorePackage/CatalogsModule/interfaces/IKnmJudgmentPunishmentTypeSelectOption';

interface IErknmJudgmentAgainstInfoProps {
  judgmentItemAgainstInfoId: string;
  judgmentItemAgainstInfoName: string;
  judgmentItemAgainstValue: IKnmErknmFormJudgmentAgainstInfo | undefined;
  watchOnly: boolean;
}

interface IErknmJudgmentAgainstInfoStoreProps {
  formRef: IKnmFormRef | undefined;
  judgmentPunishmentIndexSelectOptions: IKnmJudgmentPunishmentIndexSelectOption[] | undefined;
}

const ErknmJudgmentAgainstInfoWithoutStore = ({
  judgmentItemAgainstInfoId,
  judgmentItemAgainstInfoName,
  judgmentItemAgainstValue,
  watchOnly,
  formRef,
  judgmentPunishmentIndexSelectOptions,
}: IErknmJudgmentAgainstInfoProps & IErknmJudgmentAgainstInfoStoreProps) => {
  const [filteredPunishmentIndexSelectOptions, setFilteredPunishmentIndexSelectOptions] = useState<
    IKnmJudgmentPunishmentIndexSelectOption[] | undefined
  >(undefined);
  const handlePunishmentTypeChange = useCallback(
    (v: IKnmJudgmentPunishmentTypeSelectOption) => {
      formRef?.current.change(`${judgmentItemAgainstInfoName}.amountOfPunishment` as keyof IKnmErknmForm);
      formRef?.current.change(`${judgmentItemAgainstInfoName}.punishmentIndex` as keyof IKnmErknmForm);
      formRef?.current.change(`${judgmentItemAgainstInfoName}.punishmentNoteLawsuits` as keyof IKnmErknmForm);

      const indexOptions = judgmentPunishmentIndexSelectOptions?.filter(x => x.punishmentTypeIds.includes(v.id));

      setFilteredPunishmentIndexSelectOptions(indexOptions);

      if (indexOptions?.length === 1) {
        formRef?.current.change(
          `${judgmentItemAgainstInfoName}.punishmentIndex` as keyof IKnmErknmForm,
          indexOptions[0],
        );
      }
    },
    [formRef, judgmentItemAgainstInfoName, judgmentPunishmentIndexSelectOptions],
  );

  return (
    <>
      <Row notWrap>
        <FieldBlock id={`${judgmentItemAgainstInfoId}.prosecutionType`} size="half">
          <SelectInputFieldAutoOptions
            name={`${judgmentItemAgainstInfoName}.prosecutionType`}
            isClearable={true}
            optionName={CommonCatalogsNamesEnum.JUDGMENT_PROSECUTION_TYPES}
            placeholder="Выберите вид ответственности"
            disabled={watchOnly}
          />
        </FieldBlock>
        <FieldBlock id={`${judgmentItemAgainstInfoId}.punishmentType`} size="half">
          <SelectInputFieldAutoOptions
            name={`${judgmentItemAgainstInfoName}.punishmentType`}
            isClearable={true}
            optionName={CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_TYPES}
            placeholder="Выберите вид наказания"
            disabled={watchOnly}
            onChange={handlePunishmentTypeChange}
          />
        </FieldBlock>
      </Row>
      {judgmentItemAgainstValue?.punishmentType?.hasIndexAndAmount && (
        <Row notWrap>
          <FieldBlock id={`${judgmentItemAgainstInfoId}.amountOfPunishment`} size="half">
            <TextInputField
              name={`${judgmentItemAgainstInfoName}.amountOfPunishment`}
              disabled={watchOnly}
              placeholder="Введите размер наказания"
              type="number"
              min={0}
            />
          </FieldBlock>
          <FieldBlock id={`${judgmentItemAgainstInfoId}.punishmentIndex`} size="half">
            <SelectInputField
              name={`${judgmentItemAgainstInfoName}.punishmentIndex`}
              placeholder="Выберите показатель"
              isClearable={false}
              options={filteredPunishmentIndexSelectOptions}
              disabled={watchOnly}
            />
          </FieldBlock>
        </Row>
      )}
      {judgmentItemAgainstValue?.punishmentType?.hasText && (
        <Row notWrap>
          <FieldBlock id={`${judgmentItemAgainstInfoId}.punishmentNoteLawsuits`}>
            <TextInputField
              name={`${judgmentItemAgainstInfoName}.punishmentNoteLawsuits`}
              disabled={watchOnly}
              placeholder="Дополнительная информация (заполняется при необходимости)"
            />
          </FieldBlock>
        </Row>
      )}
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmJudgmentAgainstInfoStoreProps => ({
  formRef: getKnmFormRef(state),
  judgmentPunishmentIndexSelectOptions: getJudgmentPunishmentIndexSelectOptions(state),
});

export const ErknmJudgmentAgainstInfo = connect(mapStateToProps)(ErknmJudgmentAgainstInfoWithoutStore);
